package org.zq.astrock_ai.platform

actual object ShareHelper {
    actual fun shareText(title: String, text: String): Boolean {
        // Web Share 需安全上下文与用户手势，失败则回退剪贴板
        return runCatching {
            val nav = kotlinx.browser.window.navigator.asDynamic()
            if (nav.share != null) {
                val payload = js("{title: '', text: ''}")
                payload.title = title
                payload.text = text
                nav.share(payload)
                true
            } else {
                ClipboardHelper.copyText(text)
            }
        }.getOrDefault(ClipboardHelper.copyText(text))
    }
}
